import React, { useEffect, useState } from 'react';

import styled from 'styled-components';

/** helpers */
import { formatPercent, formatUSDCurrency } from '../helpers/format';

const ErrorText = styled.p`
  color: red;
  margin-bottom: 20px;

  a {
    background: burlywood;
    cursor: pointer;
  }
`;

export default function LoanDetails({
  loanDetailsData,
  toggleLoanDetailsVisible,
  latestLoanDetails,
  fetchApprovedAmazonLoanDetailsData,
}) {
  const [apr, setApr] = useState(0);
  const [disbursedAmount, setDisbursedAmount] = useState(0);
  const [loanAmount, setLoanAmount] = useState(0);
  const [loanFee, setLoanFee] = useState(0);
  const [loanRate, setLoanRate] = useState(0);
  const [loanTerm, setLoanTerm] = useState(0);
  const [monthlyPayment, setMonthlyPayment] = useState(0);
  const [prePaymentPenalty, setPrePaymentPenalty] = useState(0);

  useEffect(() => {
    // get loan details
    setApr(loanDetailsData?.apr);
    setDisbursedAmount(loanDetailsData?.disbursedAmount);
    setLoanAmount(loanDetailsData?.loanAmount);
    setLoanFee(loanDetailsData?.loanFee);
    setLoanRate(loanDetailsData?.loanRate);
    setLoanTerm(loanDetailsData?.loanTerm);
    setMonthlyPayment(loanDetailsData?.monthlyPayment);
    setPrePaymentPenalty(loanDetailsData?.prePaymentPenalty);
  }, [loanDetailsData]);

  return (
    <div className="amazon-loan">
      {!latestLoanDetails && (
        <ErrorText>
          Something went wrong! Please update data manually by clicking{' '}
          <a onClick={fetchApprovedAmazonLoanDetailsData}>
            &nbsp;&nbsp;&nbsp;here&nbsp;&nbsp;&nbsp;
          </a>
        </ErrorText>
      )}
      <div className="amazon-loan__title">Loan details</div>
      <div className="amazon-loan__details">
        <div className="amazon-loan__details__item">
          <div className="amazon-loan__details__item__value">{formatUSDCurrency(loanAmount)}</div>
          <div className="amazon-loan__details__item__title">Loan Amount</div>
        </div>
        <div className="amazon-loan__details__item">
          <div className="amazon-loan__details__item__value">{loanTerm}</div>
          <div className="amazon-loan__details__item__title">Loan Term</div>
        </div>
        <div className="amazon-loan__details__item">
          <div className="amazon-loan__details__item__value">
            {formatUSDCurrency(monthlyPayment)}
          </div>
          <div className="amazon-loan__details__item__title">Monthly Payment</div>
        </div>
        <div className="amazon-loan__details__item">
          <div className="amazon-loan__details__item__value">
            {formatUSDCurrency(prePaymentPenalty)}
          </div>
          <div className="amazon-loan__details__item__title">Pre-payment Penalty</div>
        </div>
      </div>
      <div className="amazon-loan__details">
        <div className="amazon-loan__details__item">
          <div className="amazon-loan__details__item__value">{formatUSDCurrency(loanFee)}</div>
          <div className="amazon-loan__details__item__title">Loan Fee</div>
        </div>
        <div className="amazon-loan__details__item">
          <div className="amazon-loan__details__item__value">
            {formatUSDCurrency(disbursedAmount)}
          </div>
          <div className="amazon-loan__details__item__title">Disbursed Amount</div>
        </div>
        <div className="amazon-loan__details__item">
          <div className="amazon-loan__details__item__value">{formatPercent(loanRate / 100)}</div>
          <div className="amazon-loan__details__item__title">Loan Rate</div>
        </div>
        <div className="amazon-loan__details__item">
          <div className="amazon-loan__details__item__value">{formatPercent(apr / 100)}</div>
          <div className="amazon-loan__details__item__title">APR</div>
        </div>
      </div>
      <div className="amazon-loan__hide">
        <button className="amazon-loan__hide__button" onClick={toggleLoanDetailsVisible}>
          Hide Loan Details
        </button>
      </div>
    </div>
  );
}
